/* <artifact-specification>

I need a error card, it should only show ErrorCode and ErrorText

based on the following props:

{ data: 
{
    "ErrorText": "Flux Capacitor Overload",
    "ErrorCode": 500      
}}

</artifact-specification> */

import React from 'react';
import { Card, CardHeader, CardContent } from '@/components/ui/card';
import { AlertCircle } from 'lucide-react';

const APIErrorGeneric = ({ data = { ErrorText: "", ErrorCode: 0 } } = {}) => {
  return (
    <Card className="border-destructive">
      <CardHeader className="flex flex-row items-center gap-2 text-destructive">
        <AlertCircle className="h-5 w-5" />
        <span className="font-semibold">Error {data.ErrorCode}</span>
      </CardHeader>
      <CardContent>
        <p className="text-destructive">{data.ErrorText}</p>
      </CardContent>
    </Card>
  );
};

export default APIErrorGeneric;